module.exports = __webpack_public_path__ + "static/media/Malsae1 Translated by J_Lee_77777.eb902bda.md";